import { isAxiosError } from 'axios'

export const CROP_SAVE_PERMISSION_ERROR =
  "You don't have permission to create a zone reference image for this asset. Ask an administrator to grant you edit access."

export const CROP_SAVE_GENERIC_ERROR =
  'Failed to save zone reference image. Please try again.'

export const getCropSaveErrorMessage = (error: unknown): string =>
  isAxiosError(error) && error.response?.status === 403
    ? CROP_SAVE_PERMISSION_ERROR
    : CROP_SAVE_GENERIC_ERROR
